import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const BusinessOverviewPage = lazy(() => import('src/pages/business-overview/business-overview'));

// ----------------------------------------------------------------------

export const businessOverviewRoutes = [
  {
    path: 'business-overview',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [{ element: <BusinessOverviewPage />, index: true }],
  },
];
